import { createSlice } from "@reduxjs/toolkit";

const sellingCartsSlice = createSlice({
  name: "sellingCart",
  initialState: {
    cartItem: [],
    discount: 0,
    total: 0,
    vat: 0,
    vatPercentage: 0,
  },
  reducers: {
    updateCart: (state, action) => {
      state.cartItem = action.payload.cart;
      state.total = action.payload.total;
    },
    // This action to set discount
    setDiscount: (state, action) => {
      state.discount = action.payload.discountAmount;
    },
    setVat: (state, action) => {
      state.vat = action.payload.vat; // in real money
    },

    setVatPercentage: (state, action) => {
      state.vatPercentage = action.payload.vatPercentage; // in percentage
    },

    clearCart: (state) => {
      state.cartItem = [];
      state.total = 0;
      state.discount = 0;
      state.vat = 0;
      state.vatPercentage = 0;
    },
  },
});

export default sellingCartsSlice.reducer;
export const { updateCart, clearCart, setDiscount, setVatPercentage, setVat } = sellingCartsSlice.actions;
